<template>
<div>

	<!-- page-heading -->
	<page-heading :show="true" pageTitle="ECS-HEADER"></page-heading>

	<div class="columns">

		<div class="col-main">

			<!-- show loading indicator -->
			<loading-indicator :loading="isLoading"></loading-indicator>

			<div v-if="!isLoading" class="tblWrapper equipments">


				<!--
				<div class="tblHeaderOptions is-clearfix">

					<form class="control has-addons is-pulled-left" @submit.prevent="search()">

						<input class="input" type="text" v-model.trim="searchString" placeholder="Suchbegriff">

						<span class="button is-info" @click="search()">
							<span class="icon is-small"><i class="fa fa-search"></i></span>
						</span>

					</form>

				</div>
				-->



				<v-client-table ref="tblEquipmentCatalogSections" name="tblEquipmentCatalogSections" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions" class="noFirstColumn">

					<!-- before table: FILTER OPTIONS -->
	                <template slot="beforeTable">

	                    <div class="columns is-marginless filters">

	                        <!--search -->
	                        <div class="column is-narrow">
	                            <div class="control has-icon search">
	                                <input class="input" type="text" v-model.trim="searchString" placeholder="Suchbegriff">
	                                <i class="fa fa-search" aria-hidden="true"></i>
	                            </div>
	                        </div>

	                    </div>

	                </template>

				</v-client-table>

			</div>

		</div>

        <div class="col-aside">

    		<affix :offset="50">

                <div class="sidebox">
					<custom-button type="blue" name="ECS-BTN-SECTION_ADD" icon="icon-ak-hinzufuegen" @click.native="newSection"></custom-button>
				</div>

    		</affix>

        </div>

    </div>

</div>

</template>





<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

export default {

    name: 'equipmentCatalogSections',

	components: {

	},

	data() {

        return {
            isLoading: true,
            searchString: null,

            table: {

                tblColumns: ['name', 'color'],
                tblData: [],
                tblOptions: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: true,
                    perPage: 25,
                    orderBy: {
                        ascending: true,
                        column: 'name'
                    },

                    // custom table headings - make them clickable for language Setting
                    headings: {

                        name: function(h) {
                            return <lang labelKey="ECS-TBL_HEADER-NAME"></lang>
                        },
						color: function(h) {
                            return <lang labelKey="ECS-TBL_HEADER-COLOR"></lang>
                        },

                    },

                    sortable: ['name'],
					sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },
                    filterByColumn: false,
                    filterable: false,

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

					// custom filter functions
					customFilters: [
						{
							name: 'search',
							callback(row, string) {

								if(string == null || string == "") {
									return true;
								}

								string = string.toLowerCase();
                                return row.name != null && row.name.toLowerCase().indexOf(string) > -1;

							}
						},
                    ],

                }
            }

        }
    },

	watch: {

        searchString(val) {
            Event.$emit('vue-tables.tblEquipmentCatalogSections.filter::search', val);
		},

    },

    created() {

        this.fetchData();

    },

    mounted() {

        Event.$on('vue-tables.tblEquipmentCatalogSections.row-click', function (data) {
            this.$router.push({ name: 'equipmentCatalogSection', params: { 'equipmentCatalogSectionID': data.row.id }  });
        }.bind(this));

    },

    methods: {

        newSection() {

            this.$router.push({ name: 'equipmentCatalogSectionNew' });
	    },

        fetchData() {

			this.isLoading = true;
			var self = this;

			// make the request
			this.axios.get(self.$config.api + 'equipmentCatalogSection')
                .then(function(response) {

					self.table.tblData = response.data.equipmentCatalogSection;
					self.isLoading = false;

                }).catch(function(error) {
                    self.isLoading = false;
					console.log(error);
				});
		},

    }

}
</script>


<style>

</style>
